import RecentTransaction from "components/RecentTransactions/RecentTransactions";
import { useMemo } from "react";
import { useGetWalletTransationsV2Query } from "services/walletApi";
import { toQueryString } from "util/utils";

export default function Transactions(props) {
  const { subjectOf = "buy_debit" } = props;

  // subjectOf == sell_credit | buy_debit

  const queries = useMemo(
    () => toQueryString({ limit: 5, subjectOfTransaction: subjectOf }),
    [subjectOf]
  );

  const { data, isLoading } = useGetWalletTransationsV2Query(queries);
  const transactions = useMemo(() => data?.transactions, [data]);

  console.log("TRANSACTIONS", transactions);

  return (
    <>
      <RecentTransaction
        isLoading={isLoading}
        transactions={transactions}
        showTitle={false}
        _tx={{ pointerEvents: "none" }}
      />
    </>
  );
}
